(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2826],{

/***/ 98746:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Box_Box; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/pureProps.js
var pureProps = __webpack_require__(7820);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/utility.js
var props_utility = __webpack_require__(18981);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/spacing.js
var props_spacing = __webpack_require__(2349);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/sx.js
var props_sx = __webpack_require__(23720);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Box/Box.js








const Box = (param)=>/*#__PURE__*/ {
    let { className ="" , borderRadius , borderWidth , borderColor , bgColor , indent =false , shadow =false , overflow , utility ={
        ...props_utility/* utilityProps */.Gm
    } , sx ={
        ...props_sx/* sxProps */.ET
    } , spacing ={
        ...props_spacing/* spacingProps */.tF
    } , children , ...props } = param;
    return (0,jsx_runtime.jsx)("div", {
        className: (0,classes/* classes */.S)("box", indent && "box--indent", overflow && "overflow--".concat(overflow), shadow && "box--shadow", ...(0,props_utility/* utilityClassName */.b2)((0,pureProps/* deepMergeProps */.p)({
            bgColor,
            radius: borderRadius,
            border: {
                width: borderWidth,
                color: borderColor
            }
        }, (0,pureProps/* default */.Z)(utility))), ...(0,props_sx/* sxClassName */.ZA)(sx), ...(0,props_spacing/* spacingClassName */.RB)(spacing), className),
        ...props,
        children: children
    });
};
Box.propTypes = {
    className: prop_types.string,
    borderRadius: prop_types.number,
    borderWidth: (0,prop_types.oneOf)([
        1,
        2,
        3,
        4
    ]),
    borderColor: prop_types.string,
    bgColor: prop_types.string,
    overflow: (0,prop_types.oneOf)([
        "hidden"
    ]),
    indent: prop_types.bool,
    shadow: prop_types.bool,
    utility: props_utility/* utilityPropTypes */.pQ,
    sx: props_sx/* sxPropTypes */.I1,
    spacing: props_spacing/* spacingPropTypes */.Xj,
    children: prop_types.node.isRequired
};
/* harmony default export */ var Box_Box = (Box);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Box/index.js



/***/ }),

/***/ 14593:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36432);




const HeroAction = (param)=>/*#__PURE__*/ {
    let { center =true , children  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .HeroRow */ .P, {
        center: center,
        className: "section-hero__action",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .HeroCol */ .Z, {
            children: children
        })
    });
};
HeroAction.propTypes = {
    center: prop_types__WEBPACK_IMPORTED_MODULE_3__.bool,
    children: prop_types__WEBPACK_IMPORTED_MODULE_3__.node.isRequired
};
/* harmony default export */ __webpack_exports__["Z"] = (HeroAction);


/***/ }),

/***/ 85765:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18774);
/* harmony import */ var _utils_classes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67924);





const HeroButtonLink = (param)=>{
    let { className ="" , size ="s" , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"].Link */ .Z.Link, {
        size: size,
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_3__/* .classes */ .S)("section-hero__button", className),
        ...props
    });
};
HeroButtonLink.propTypes = {
    className: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    size: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    ..._Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"].propTypes */ .Z.propTypes
};
/* harmony default export */ __webpack_exports__["Z"] = (HeroButtonLink);


/***/ }),

/***/ 36432:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ HeroRow; },
/* harmony export */   "Z": function() { return /* binding */ HeroCol; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67478);



const HeroCol = (param)=>{
    let { ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Col */ .JX, {
        md: "shrink",
        ...props
    });
};
HeroCol.propTypes = {
    ..._Grid__WEBPACK_IMPORTED_MODULE_2__/* .Col.propTypes */ .JX.propTypes
};
const HeroRow = (param)=>{
    let { ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Row */ .X2, {
        mx: true,
        my: true,
        center: true,
        ...props
    });
};
HeroRow.propTypes = {
    ..._Grid__WEBPACK_IMPORTED_MODULE_2__/* .Row.propTypes */ .X2.propTypes
};


/***/ }),

/***/ 91319:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Heading__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42866);
/* harmony import */ var _utils_classes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67924);
/* harmony import */ var _utils_pureProps__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(7820);
/* harmony import */ var _props_sx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23720);
/* harmony import */ var _props_spacing__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2349);
/* harmony import */ var _props_utility__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(18981);








const HeroTitle = (param)=>{
    let { align , color , className ="" , utility ={
        ..._props_utility__WEBPACK_IMPORTED_MODULE_6__/* .utilityProps */ .Gm
    } , sx ={
        ..._props_sx__WEBPACK_IMPORTED_MODULE_4__/* .sxProps */ .ET
    } , spacing ={
        ..._props_spacing__WEBPACK_IMPORTED_MODULE_5__/* .spacingProps */ .tF
    } , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Heading__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        Tag: "h1",
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_3__/* .classes */ .S)("section-hero__title", ...(0,_props_utility__WEBPACK_IMPORTED_MODULE_6__/* .utilityClassName */ .b2)(utility), ...(0,_props_sx__WEBPACK_IMPORTED_MODULE_4__/* .sxClassName */ .ZA)((0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_7__/* .deepMergeProps */ .p)({
            fontColor: color,
            textAlign: align
        }, (0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(sx)), true), ...(0,_props_spacing__WEBPACK_IMPORTED_MODULE_5__/* .spacingClassName */ .RB)(spacing), className),
        ...props
    });
};
HeroTitle.propTypes = {
    align: _props_sx__WEBPACK_IMPORTED_MODULE_4__/* .textAlignPropTypes */ .g4,
    ..._Heading__WEBPACK_IMPORTED_MODULE_2__/* ["default"].propTypes */ .Z.propTypes
};
/* harmony default export */ __webpack_exports__["Z"] = (HeroTitle);


/***/ }),

/***/ 93072:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _utils_AssetsProvider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(84154);
/* harmony import */ var _utils_classes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67924);





const HeroWrapper = (param)=>{
    let { isBaseUrl =true , bgImage ="" , className ="" , children , ...props } = param;
    const baseUrl = isBaseUrl ? (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_utils_AssetsProvider__WEBPACK_IMPORTED_MODULE_2__/* ["default"].context */ .Z.context) : "";
    const styles = bgImage ? {
        style: {
            backgroundImage: "url('".concat(baseUrl).concat(bgImage, "')")
        }
    } : {};
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_3__/* .classes */ .S)("section-hero-wrapper", className),
        ...styles,
        ...props,
        children: children
    });
};
HeroWrapper.propTypes = {
    isBaseUrl: prop_types__WEBPACK_IMPORTED_MODULE_4__.bool,
    bgImage: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    className: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    children: prop_types__WEBPACK_IMPORTED_MODULE_4__.node.isRequired
};
/* harmony default export */ __webpack_exports__["Z"] = (HeroWrapper);


/***/ }),

/***/ 69591:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Hero_Hero; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Section/index.js + 1 modules
var Section = __webpack_require__(93512);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Grid/index.js
var Grid = __webpack_require__(67478);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/spacing.js
var props_spacing = __webpack_require__(2349);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/sx.js
var props_sx = __webpack_require__(23720);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/utility.js
var props_utility = __webpack_require__(18981);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Hero/Hero.js









const Hero = (param)=>{
    let { align ="center" , children , color ="black--02" , utility ={
        ...props_utility/* utilityProps */.Gm
    } , sx ={
        ...props_sx/* sxProps */.ET
    } , spacing ={
        ...props_spacing/* spacingProps */.tF
    } , className ="" , backgroundImage  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* default */.Z, {
        className: (0,classes/* classes */.S)("section-hero", align && "section-hero-text-".concat(align), color && "section-hero-color-".concat(color), "".concat(backgroundImage ? "section-hero-custom-background" : ""), ...(0,props_utility/* utilityClassName */.b2)(utility), ...(0,props_sx/* sxClassName */.ZA)(sx), ...(0,props_spacing/* spacingClassName */.RB)(spacing), className),
        style: {
            ...backgroundImage && {
                backgroundImage: "url(".concat(backgroundImage, ")")
            }
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Container */.W2, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                    children: children
                })
            })
        })
    });
};
Hero.propTypes = {
    align: props_sx/* textAlignPropTypes */.g4,
    className: prop_types.string,
    children: prop_types.node.isRequired,
    color: (0,prop_types.oneOf)([
        "1",
        "1--light",
        "2",
        "3",
        "4",
        "5",
        "6",
        "white",
        "black--02",
        "transparent",
        "gradient"
    ]),
    backgroundImage: prop_types.string,
    utility: props_utility/* utilityPropTypes */.pQ,
    sx: props_sx/* sxPropTypes */.I1,
    spacing: props_spacing/* spacingPropTypes */.Xj
};
/* harmony default export */ var Hero_Hero = (Hero);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Hero/index.js



/***/ }),

/***/ 7267:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _utils_classes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67924);
/* harmony import */ var _props_spacing__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2349);





const ImageCaption = (param)=>{
    let { isBlock =false , caption ="" , spacing ={
        ..._props_spacing__WEBPACK_IMPORTED_MODULE_3__/* .spacingProps */ .tF
    } , className ="" , children  } = param;
    const Tag = isBlock ? "div" : "span";
    const captionText = caption;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Tag, {
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_2__/* .classes */ .S)("image-caption", isBlock && "image-caption--block", ...(0,_props_spacing__WEBPACK_IMPORTED_MODULE_3__/* .spacingClassName */ .RB)(spacing), className),
        children: [
            children,
            captionText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "image-caption__text",
                children: captionText
            })
        ]
    });
};
ImageCaption.propTypes = {
    isBlock: prop_types__WEBPACK_IMPORTED_MODULE_4__.bool,
    className: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    caption: prop_types__WEBPACK_IMPORTED_MODULE_4__.node,
    spacing: _props_spacing__WEBPACK_IMPORTED_MODULE_3__/* .spacingPropTypes */ .Xj,
    children: prop_types__WEBPACK_IMPORTED_MODULE_4__.node.isRequired
};
/* harmony default export */ __webpack_exports__["Z"] = (ImageCaption);


/***/ }),

/***/ 72989:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _Grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67478);
/* harmony import */ var _Link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25522);
/* harmony import */ var _Section__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93512);
/* harmony import */ var _Heading__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(42866);
/* harmony import */ var _Block__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6949);
/* harmony import */ var _r1_atoms_ContentContainer__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(12985);
/* harmony import */ var _utils_classes__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(67924);
/* harmony import */ var _utils_pureProps__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(7820);
/* harmony import */ var _props_sx__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(23720);
/* harmony import */ var _props_spacing__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(2349);
/* harmony import */ var _props_utility__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(18981);














const Title = (param)=>/*#__PURE__*/ {
    let { className ="" , color , utility ={
        ..._props_utility__WEBPACK_IMPORTED_MODULE_11__/* .utilityProps */ .Gm
    } , sx ={
        ..._props_sx__WEBPACK_IMPORTED_MODULE_9__/* .sxProps */ .ET
    } , spacing ={
        ..._props_spacing__WEBPACK_IMPORTED_MODULE_10__/* .spacingProps */ .tF
    } , children , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Heading__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        Tag: "h2",
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_8__/* .classes */ .S)("landing-simple-section__title", ...(0,_props_utility__WEBPACK_IMPORTED_MODULE_11__/* .utilityClassName */ .b2)(utility), ...(0,_props_sx__WEBPACK_IMPORTED_MODULE_9__/* .sxClassName */ .ZA)((0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_12__/* .deepMergeProps */ .p)({
            fontColor: color,
            textAlign: "center"
        }, (0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(sx)), true), ...(0,_props_spacing__WEBPACK_IMPORTED_MODULE_10__/* .spacingClassName */ .RB)((0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_12__/* .deepMergeProps */ .p)({
            mb: 0,
            mt: 0
        }, (0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(spacing))), className),
        ...props,
        children: children
    });
};
Title.propTypes = {
    ..._Heading__WEBPACK_IMPORTED_MODULE_5__/* ["default"].propTypes */ .Z.propTypes
};
const TitleV2 = (param)=>/*#__PURE__*/ {
    let { className ="" , color , children , utility ={
        ..._props_utility__WEBPACK_IMPORTED_MODULE_11__/* .utilityProps */ .Gm
    } , sx ={
        ..._props_sx__WEBPACK_IMPORTED_MODULE_9__/* .sxProps */ .ET
    } , spacing ={
        ..._props_spacing__WEBPACK_IMPORTED_MODULE_10__/* .spacingProps */ .tF
    } , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Heading__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        Tag: "h2",
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_8__/* .classes */ .S)("landing-simple-section__title-v2", ...(0,_props_utility__WEBPACK_IMPORTED_MODULE_11__/* .utilityClassName */ .b2)(utility), ...(0,_props_sx__WEBPACK_IMPORTED_MODULE_9__/* .sxClassName */ .ZA)((0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_12__/* .deepMergeProps */ .p)({
            fontColor: color,
            textAlign: "center"
        }, (0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(sx)), true), ...(0,_props_spacing__WEBPACK_IMPORTED_MODULE_10__/* .spacingClassName */ .RB)((0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_12__/* .deepMergeProps */ .p)({
            mb: 0,
            mt: 0
        }, (0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(spacing))), className),
        ...props,
        children: children
    });
};
TitleV2.propTypes = {
    ..._Heading__WEBPACK_IMPORTED_MODULE_5__/* ["default"].propTypes */ .Z.propTypes
};
const DescriptionV2 = (param)=>/*#__PURE__*/ {
    let { className ="" , color , children , utility ={
        ..._props_utility__WEBPACK_IMPORTED_MODULE_11__/* .utilityProps */ .Gm
    } , sx ={
        ..._props_sx__WEBPACK_IMPORTED_MODULE_9__/* .sxProps */ .ET
    } , spacing ={
        ..._props_spacing__WEBPACK_IMPORTED_MODULE_10__/* .spacingProps */ .tF
    }  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Block__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_8__/* .classes */ .S)("landing-simple-section__description-v2", ...(0,_props_utility__WEBPACK_IMPORTED_MODULE_11__/* .utilityClassName */ .b2)(utility), ...(0,_props_sx__WEBPACK_IMPORTED_MODULE_9__/* .sxClassName */ .ZA)((0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_12__/* .deepMergeProps */ .p)({
            fontColor: color,
            fontSize: "l",
            textAlign: "center"
        }, (0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(sx))), ...(0,_props_spacing__WEBPACK_IMPORTED_MODULE_10__/* .spacingClassName */ .RB)((0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_12__/* .deepMergeProps */ .p)({
            mt: 4
        }, (0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(spacing))), className),
        children: children
    });
};
DescriptionV2.propTypes = {
    color: _props_sx__WEBPACK_IMPORTED_MODULE_9__/* .colorPropTypes */ .AK,
    ..._Block__WEBPACK_IMPORTED_MODULE_6__/* ["default"].propTypes */ .Z.propTypes
};
const Body = (param)=>/*#__PURE__*/ {
    let { children =null  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: children
    });
};
Body.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_13__.node
};
const Action = (param)=>/*#__PURE__*/ {
    let { ActionComponent =_Link__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z , children , ...props } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Row */ .X2, {
        utility: {
            justify: "center"
        },
        spacing: {
            mt: 8
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Col */ .JX, {
            sx: {
                textAlign: "center"
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ActionComponent, {
                ...props,
                children: children
            })
        })
    });
};
Action.propTypes = {
    ActionComponent: prop_types__WEBPACK_IMPORTED_MODULE_13__.elementType,
    children: prop_types__WEBPACK_IMPORTED_MODULE_13__.node.isRequired
};
const LandingSimpleSection = (param)=>{
    let { className ="" , isBorderNone =false , bgColor , utility ={
        ..._props_utility__WEBPACK_IMPORTED_MODULE_11__/* .utilityProps */ .Gm
    } , spacing ={
        ..._props_spacing__WEBPACK_IMPORTED_MODULE_10__/* .spacingProps */ .tF
    } , children , containerProps , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Section__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_8__/* .classes */ .S)("landing-simple-section", !isBorderNone && "landing-simple-section--border-bottom", ...(0,_props_utility__WEBPACK_IMPORTED_MODULE_11__/* .utilityClassName */ .b2)((0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_12__/* .deepMergeProps */ .p)({
            bgColor
        }, (0,_utils_pureProps__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(utility))), ...(0,_props_spacing__WEBPACK_IMPORTED_MODULE_10__/* .spacingClassName */ .RB)(spacing), className),
        ...props,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_r1_atoms_ContentContainer__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
            ...containerProps,
            children: children
        })
    });
};
LandingSimpleSection.propTypes = {
    bgColor: _props_sx__WEBPACK_IMPORTED_MODULE_9__/* .colorPropTypes */ .AK,
    isBorderNone: prop_types__WEBPACK_IMPORTED_MODULE_13__.bool,
    containerProps: (0,prop_types__WEBPACK_IMPORTED_MODULE_13__.shape)({
        sm: (0,prop_types__WEBPACK_IMPORTED_MODULE_13__.oneOf)([
            "",
            "auto",
            "shrink",
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11,
            12
        ]),
        md: (0,prop_types__WEBPACK_IMPORTED_MODULE_13__.oneOf)([
            "",
            "auto",
            "shrink",
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11,
            12
        ]),
        lg: (0,prop_types__WEBPACK_IMPORTED_MODULE_13__.oneOf)([
            "",
            "auto",
            "shrink",
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11,
            12
        ]),
        center: prop_types__WEBPACK_IMPORTED_MODULE_13__.bool
    }),
    ..._Section__WEBPACK_IMPORTED_MODULE_4__/* ["default"].propTypes */ .Z.propTypes
};
const SectionLabel = (param)=>{
    let { utility ={
        ..._props_utility__WEBPACK_IMPORTED_MODULE_11__/* .utilityProps */ .Gm
    } , sx ={
        ..._props_sx__WEBPACK_IMPORTED_MODULE_9__/* .sxProps */ .ET
    } , spacing ={
        ..._props_spacing__WEBPACK_IMPORTED_MODULE_10__/* .spacingProps */ .tF
    } , className ="" , children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Block__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        className: (0,_utils_classes__WEBPACK_IMPORTED_MODULE_8__/* .classes */ .S)("landing-simple-section__label", ...(0,_props_utility__WEBPACK_IMPORTED_MODULE_11__/* .utilityClassName */ .b2)(utility), ...(0,_props_sx__WEBPACK_IMPORTED_MODULE_9__/* .sxClassName */ .ZA)(sx), ...(0,_props_spacing__WEBPACK_IMPORTED_MODULE_10__/* .spacingClassName */ .RB)(spacing), className),
        children: children
    });
};
SectionLabel.propTypes = {
    ..._Block__WEBPACK_IMPORTED_MODULE_6__/* ["default"].propTypes */ .Z.propTypes
};
LandingSimpleSection.Label = SectionLabel;
LandingSimpleSection.Title = Title;
LandingSimpleSection.TitleV2 = TitleV2;
LandingSimpleSection.DescriptionV2 = DescriptionV2;
LandingSimpleSection.Body = Body;
LandingSimpleSection.Action = Action;
/* harmony default export */ __webpack_exports__["Z"] = (LandingSimpleSection);


/***/ }),

/***/ 37045:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _SimpleSection__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72989);




const LandingSimpleSectionStripped = (param)=>{
    let { isDark =false , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SimpleSection__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        utility: {
            bgColor: isDark ? "black--02" : null
        },
        isBorderNone: true,
        ...props
    });
};
LandingSimpleSectionStripped.propTypes = {
    isDark: prop_types__WEBPACK_IMPORTED_MODULE_3__.bool,
    ..._SimpleSection__WEBPACK_IMPORTED_MODULE_2__/* ["default"].propTypes */ .Z.propTypes
};
/* harmony default export */ __webpack_exports__["Z"] = (LandingSimpleSectionStripped);


/***/ }),

/***/ 15945:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Line_Line; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/utility.js
var props_utility = __webpack_require__(18981);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/spacing.js
var props_spacing = __webpack_require__(2349);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Line/Line.js






const Line = (param)=>{
    let { className ="" , opacity ="" , isGradient =false , utility ={
        ...props_utility/* utilityProps */.Gm
    } , spacing ={
        ...props_spacing/* spacingProps */.tF
    }  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,classes/* classes */.S)("line", opacity && "line--opacity-".concat(opacity), isGradient && "line--gradient", ...(0,props_utility/* utilityClassName */.b2)(utility), ...(0,props_spacing/* spacingClassName */.RB)(spacing), className)
    });
};
Line.propTypes = {
    className: prop_types.string,
    opacity: (0,prop_types.oneOf)([
        0,
        10,
        20,
        30,
        40,
        50,
        60,
        70,
        80,
        90,
        100
    ]),
    isGradient: prop_types.bool,
    utility: props_utility/* utilityPropTypes */.pQ,
    spacing: props_spacing/* spacingPropTypes */.Xj
};
/* harmony default export */ var Line_Line = (Line);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Line/index.js



/***/ }),

/***/ 13398:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Panel_Panel; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Block/index.js + 1 modules
var Block = __webpack_require__(6949);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Panel/Panel.js





const Panel = (param)=>{
    let { className ="" , shadow , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Block/* default */.Z, {
        className: (0,classes/* classes */.S)("panel", shadow && "panel--shadow", className),
        ...props
    });
};
Panel.propTypes = {
    shadow: prop_types.bool,
    ...Block/* default.propTypes */.Z.propTypes
};
/* harmony default export */ var Panel_Panel = (Panel);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/Panel/index.js



/***/ }),

/***/ 87385:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ SimpleTemplate_SimpleTemplate; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Section/index.js + 1 modules
var Section = __webpack_require__(93512);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Grid/index.js
var Grid = __webpack_require__(67478);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/Panel/index.js + 1 modules
var Panel = __webpack_require__(13398);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/color.js
var color = __webpack_require__(68657);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/sx.js
var props_sx = __webpack_require__(23720);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/utility.js
var props_utility = __webpack_require__(18981);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/SimpleTemplate/SimpleTemplate.js










const SimpleTemplate = (param)=>{
    let { cellWidth =8 , mdCellWidth =10 , paddingTop ="pt-9 pt-9--md" , paddingBottom ="pb-18 pb-18--md" , panel =true , panelPaddingY =16 , panelUtility ={
        ...props_utility/* utilityProps */.Gm
    } , children , bgColor =color/* bgColorBlack2 */.vk , className ="" , shadow =true , utility ={
        ...props_utility/* utilityProps */.Gm
    } , sx ={
        ...props_sx/* sxProps */.ET
    } , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* default */.Z, {
        className: (0,classes/* classes */.S)(paddingTop, paddingBottom, !(utility && utility.bgColor) && bgColor, ...(0,props_utility/* utilityClassName */.b2)(utility), ...(0,props_sx/* sxClassName */.ZA)(sx), className),
        ...props,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Container */.W2, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                px: true,
                utility: {
                    justify: "center"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                    md: mdCellWidth,
                    lg: cellWidth,
                    children: panel ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Panel/* default */.Z, {
                        shadow: shadow,
                        utility: panelUtility,
                        spacing: {
                            py: panelPaddingY
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Row */.X2, {
                            mx: true,
                            px: true,
                            utility: {
                                justify: "center"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* Col */.JX, {
                                md: 10,
                                children: children
                            })
                        })
                    }) : children
                })
            })
        })
    });
};
SimpleTemplate.propTypes = {
    shadow: prop_types.bool,
    cellWidth: prop_types.number,
    mdCellWidth: prop_types.number,
    paddingTop: prop_types.string,
    paddingBottom: prop_types.string,
    panel: prop_types.bool,
    panelPaddingY: prop_types.number,
    panelUtility: props_utility/* utilityPropTypes */.pQ,
    children: prop_types.node.isRequired,
    bgColor: prop_types.string,
    utility: props_utility/* utilityPropTypes */.pQ,
    sx: props_sx/* sxPropTypes */.I1,
    className: prop_types.string
};
/* harmony default export */ var SimpleTemplate_SimpleTemplate = (SimpleTemplate);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/SimpleTemplate/index.js



/***/ }),

/***/ 51192:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ UList_UList; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/utils/classes.js
var classes = __webpack_require__(67924);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/spacing.js
var props_spacing = __webpack_require__(2349);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/sx.js
var props_sx = __webpack_require__(23720);
// EXTERNAL MODULE: ./node_modules/@insightfulscience/atomic-react/props/utility.js
var props_utility = __webpack_require__(18981);
;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/UList/UList.js







const UListItem = (param)=>{
    let { bulletColor , size , utility ={
        ...props_utility/* utilityProps */.Gm
    } , sx ={
        ...props_sx/* sxProps */.ET
    } , spacing ={
        ...props_spacing/* spacingProps */.tF
    } , className ="" , children , ...props } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
        className: (0,classes/* classes */.S)("li", size && "text-".concat(size), bulletColor && "li--bullet-color-".concat(bulletColor), ...(0,props_utility/* utilityClassName */.b2)(utility), ...(0,props_sx/* sxClassName */.ZA)(sx), ...(0,props_spacing/* spacingClassName */.RB)(spacing), className),
        ...props,
        children: children
    });
};
UListItem.propTypes = {
    size: props_sx/* fontSizePropTypes */.Gk,
    bulletColor: (0,prop_types.oneOf)([
        "orange",
        "dotmatics-7",
        "black--custom-1"
    ]),
    className: prop_types.string,
    children: prop_types.node.isRequired,
    utility: props_utility/* utilityPropTypes */.pQ,
    sx: props_sx/* sxPropTypes */.I1,
    spacing: props_spacing/* spacingPropTypes */.Xj
};
const UList = (param)=>{
    let { type ="default" , spacing ={
        ...props_spacing/* spacingProps */.tF
    } , className ="" , children  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
        className: (0,classes/* classes */.S)("ul", "ul-".concat(type), ...(0,props_spacing/* spacingClassName */.RB)(spacing), className),
        children: children
    });
};
UList.propTypes = {
    type: (0,prop_types.oneOf)([
        "default",
        "pros",
        "cons"
    ]),
    className: prop_types.string,
    children: prop_types.node.isRequired,
    spacing: props_spacing/* spacingPropTypes */.Xj
};
UList.Item = UListItem;
/* harmony default export */ var UList_UList = (UList);

;// CONCATENATED MODULE: ./node_modules/@insightfulscience/atomic-react/UList/index.js



/***/ }),

/***/ 12985:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67478);




const ContentContainer = (param)=>{
    let { mx =false , px =false , my =false , py =false , sm ="" , md ="" , lg ="" , center =false , containerClassName ="" , className ="" , isFluid =false , children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Container */ .W2, {
        className: containerClassName,
        isFluid: isFluid,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Row */ .X2, {
            mx: mx,
            px: px,
            my: my,
            py: py,
            className: className,
            center: center,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Grid__WEBPACK_IMPORTED_MODULE_2__/* .Col */ .JX, {
                sm: sm,
                md: md,
                lg: lg,
                children: children
            })
        })
    });
};
ContentContainer.propTypes = {
    mx: prop_types__WEBPACK_IMPORTED_MODULE_3__.bool,
    px: prop_types__WEBPACK_IMPORTED_MODULE_3__.bool,
    my: prop_types__WEBPACK_IMPORTED_MODULE_3__.bool,
    py: prop_types__WEBPACK_IMPORTED_MODULE_3__.bool,
    sm: (0,prop_types__WEBPACK_IMPORTED_MODULE_3__.oneOf)([
        "",
        "auto",
        "shrink",
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12
    ]),
    md: (0,prop_types__WEBPACK_IMPORTED_MODULE_3__.oneOf)([
        "",
        "auto",
        "shrink",
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12
    ]),
    lg: (0,prop_types__WEBPACK_IMPORTED_MODULE_3__.oneOf)([
        "",
        "auto",
        "shrink",
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        12
    ]),
    center: prop_types__WEBPACK_IMPORTED_MODULE_3__.bool,
    containerClassName: prop_types__WEBPACK_IMPORTED_MODULE_3__.string,
    className: prop_types__WEBPACK_IMPORTED_MODULE_3__.string,
    isFluid: prop_types__WEBPACK_IMPORTED_MODULE_3__.bool,
    children: prop_types__WEBPACK_IMPORTED_MODULE_3__.node.isRequired
};
/* harmony default export */ __webpack_exports__["Z"] = (ContentContainer);


/***/ }),

/***/ 5370:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z": function() { return /* binding */ BackToTopButton; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18774);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61672);




const BackToTopButton = ()=>{
    const [showButton, setShowButton] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [prevOffset, setPrevOffset] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0);
    const toggleScrollDirection = ()=>{
        const { scrollY  } = window;
        const screenHeight = window.screen.height * 2;
        if (scrollY > prevOffset || scrollY < screenHeight) {
            setShowButton(false);
        } else if (scrollY < prevOffset && scrollY > screenHeight) {
            setShowButton(true);
        }
        setPrevOffset(scrollY);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        window.addEventListener("scroll", toggleScrollDirection);
        return ()=>{
            window.removeEventListener("scroll", toggleScrollDirection);
        };
    });
    const scrollToTop = ()=>{
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: showButton && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            className: "back-to-top-button",
            onClick: scrollToTop,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Icon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    name: "chevron-up",
                    className: "back-to-top-button--icon"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    className: "back-to-top-button--text",
                    children: "TOP"
                })
            ]
        })
    });
};


/***/ }),

/***/ 93890:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony exports MetaTwitter, MetaOGP */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _insightfulscience_atomic_react_utils_AssetsProvider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84154);





const Robots = (param)=>/*#__PURE__*/ {
    let { content =""  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
            name: "robots",
            content: content
        })
    });
};
Robots.propTypes = {
    content: prop_types__WEBPACK_IMPORTED_MODULE_4__.string
};
const Author = (param)=>/*#__PURE__*/ {
    let { content =""  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
            name: "author",
            content: content
        })
    });
};
Author.propTypes = {
    content: prop_types__WEBPACK_IMPORTED_MODULE_4__.string
};
const Canonical = (param)=>/*#__PURE__*/ {
    let { href  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
            rel: "canonical",
            href: href
        })
    });
};
Canonical.propTypes = {
    href: prop_types__WEBPACK_IMPORTED_MODULE_4__.string.isRequired
};
const CanonicalAlternate = (param)=>/*#__PURE__*/ {
    let { type ="text/html" , hrefLang , href , title =""  } = param;
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
            rel: "alternate",
            type: type,
            hrefLang: hrefLang,
            href: href,
            title: title
        })
    });
};
CanonicalAlternate.propTypes = {
    type: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    hrefLang: prop_types__WEBPACK_IMPORTED_MODULE_4__.string.isRequired,
    href: prop_types__WEBPACK_IMPORTED_MODULE_4__.string.isRequired,
    title: prop_types__WEBPACK_IMPORTED_MODULE_4__.string
};
const MetaTwitter = (param)=>{
    let { card ="" , title ="" , description ="" , site ="" , image ="" , creator ="" , isImageBaseUrl =false  } = param;
    const baseUrl = isImageBaseUrl ? (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_insightfulscience_atomic_react_utils_AssetsProvider__WEBPACK_IMPORTED_MODULE_3__/* ["default"].context */ .Z.context) : "";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: [
            title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:title",
                content: title
            }),
            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:description",
                content: description
            }),
            card && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:card",
                content: card
            }),
            site && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:site",
                content: site
            }),
            image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:image",
                content: "".concat(baseUrl).concat(image)
            }),
            creator && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "twitter:creator",
                content: creator
            })
        ]
    });
};
MetaTwitter.propTypes = {
    card: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    title: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    description: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    site: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    image: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    creator: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    isImageBaseUrl: prop_types__WEBPACK_IMPORTED_MODULE_4__.bool
};
const MetaOGP = (param)=>{
    let { isImageBaseUrl =false , title ="" , description ="" , locale ="" , type ="" , url ="" , image ="" , imageSecureUrl ="" , siteName ="" , articlePublisher =""  } = param;
    const baseUrl = isImageBaseUrl ? (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_insightfulscience_atomic_react_utils_AssetsProvider__WEBPACK_IMPORTED_MODULE_3__/* ["default"].context */ .Z.context) : "";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: [
            title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: title
            }),
            description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: description
            }),
            locale && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:locale",
                content: locale
            }),
            type && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: type
            }),
            url && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: url
            }),
            image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: "".concat(baseUrl).concat(image)
            }),
            imageSecureUrl && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image:secure_url",
                content: "".concat(baseUrl).concat(imageSecureUrl)
            }),
            siteName && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:site_name",
                content: siteName
            }),
            articlePublisher && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "article:publisher",
                content: articlePublisher
            })
        ]
    });
};
MetaOGP.propTypes = {
    isImageBaseUrl: prop_types__WEBPACK_IMPORTED_MODULE_4__.bool,
    title: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    description: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    locale: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    type: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    url: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    image: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    imageSecureUrl: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    siteName: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    articlePublisher: prop_types__WEBPACK_IMPORTED_MODULE_4__.string
};
const PageMeta = (param)=>{
    let { title ="" , description ="" , children =""  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                children: [
                    title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: title
                    }),
                    description && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: description
                    })
                ]
            }),
            children
        ]
    });
};
const CustomHead = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: children
    });
};
CustomHead.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_4__.node
};
PageMeta.Robots = Robots;
PageMeta.Custom = CustomHead;
PageMeta.Canonical = Canonical;
PageMeta.CanonicalAlternate = CanonicalAlternate;
PageMeta.Author = Author;
PageMeta.Twitter = MetaTwitter;
PageMeta.OGP = MetaOGP;
PageMeta.propTypes = {
    title: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    description: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    children: prop_types__WEBPACK_IMPORTED_MODULE_4__.node
};
/* harmony default export */ __webpack_exports__["ZP"] = (PageMeta);


/***/ }),

/***/ 4298:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports =
   false
    ? 0
    : __webpack_require__(63573)


/***/ })

}]);